import React from 'react';
// import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuMultiSelectList } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectList';

export const SbSharedRefineMenuFilterPeriodComponent = props => (
    <SbSharedRefineMenuMultiSelectList {...props} />
);

export const SbSharedRefineMenuFilterPeriod = createFragmentContainer(
    SbSharedRefineMenuFilterPeriodComponent,
    {
        searchBrowse: graphql`
            fragment SbSharedRefineMenuFilterPeriod_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuMultiSelectList_searchBrowse
            }
        `,
    }
);
